import { useState, useEffect } from 'react'

export function InstallBanner() {
  const [prompt,       setPrompt]       = useState<any>(null)
  const [show,         setShow]         = useState(false)
  const [isIOS,        setIsIOS]        = useState(false)
  const [isStandalone, setIsStandalone] = useState(false)

  useEffect(() => {
    const ios        = /iPad|iPhone|iPod/.test(navigator.userAgent)
    const standalone = window.matchMedia('(display-mode: standalone)').matches
    setIsIOS(ios)
    setIsStandalone(standalone)

    const handler = (e: Event) => {
      e.preventDefault()
      setPrompt(e)
      if (!localStorage.getItem('pwa-dismissed')) setShow(true)
    }

    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  // Show iOS instructions after 30 s
  useEffect(() => {
    if (!isIOS || isStandalone) return
    if (localStorage.getItem('pwa-dismissed')) return
    const timer = setTimeout(() => setShow(true), 30000)
    return () => clearTimeout(timer)
  }, [isIOS, isStandalone])

  const handleInstall = async () => {
    if (!prompt) return
    prompt.prompt()
    const { outcome } = await prompt.userChoice
    if (outcome === 'accepted') setShow(false)
    setPrompt(null)
  }

  const handleDismiss = () => {
    setShow(false)
    localStorage.setItem('pwa-dismissed', 'true')
  }

  if (!show || isStandalone) return null

  return (
    <div className="fixed bottom-20 left-4 right-4 max-w-[480px] mx-auto z-50">
      <div className="bg-white rounded-2xl border border-[#E8E2DC] shadow-xl p-4">

        {isIOS && !prompt ? (
          <div>
            <div className="flex items-center justify-between mb-3">
              <p className="text-sm font-semibold text-[#2C2A26]">Add Pantry to home screen</p>
              <button onClick={handleDismiss} className="text-[#B0A99F] text-xl">×</button>
            </div>
            <div className="space-y-2">
              {[
                { n: '1', t: 'Tap the Share button ⬆️' },
                { n: '2', t: 'Tap Add to Home Screen ➕' },
                { n: '3', t: 'Tap Add in the corner ✓' },
              ].map(({ n, t }) => (
                <div key={n} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-[#6B9E78] text-white text-xs font-bold
                                   flex items-center justify-center shrink-0">
                    {n}
                  </span>
                  <span className="text-xs text-[#7A7468]">{t}</span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-3">
            <img src="/pwa-192.png" alt="Pantry" className="w-12 h-12 rounded-2xl shrink-0" />
            <div className="flex-1">
              <p className="text-sm font-semibold text-[#2C2A26]">Add Pantry to home screen</p>
              <p className="text-xs text-[#7A7468]">Faster access and offline use</p>
            </div>
            <div className="flex flex-col gap-1.5">
              <button
                onClick={handleInstall}
                className="px-3 py-1.5 rounded-xl text-xs font-semibold text-white"
                style={{ background: '#6B9E78' }}
              >
                Install
              </button>
              <button
                onClick={handleDismiss}
                className="px-3 py-1.5 rounded-xl text-xs text-[#7A7468] border border-[#E8E2DC]"
              >
                Later
              </button>
            </div>
          </div>
        )}

      </div>
    </div>
  )
}
